import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';

interface GameDayStatusModalProps {
	activeModal: string;
	teamName: string;
	onClose: () => void;
	onSubmit: () => void;
}

const modalMessage: Record<string, string> = {
	withdraw: `You are about to Withdraw from this Gameday. All matches will be cancelled and all points will go to the opposing team.`,
	cancel: `You are about to Cancel this Gameday. All matches will be cancelled and no points will be awarded to either team.`
};

export const GameDayStatusModal = ({ activeModal, teamName, onClose, onSubmit }: GameDayStatusModalProps) => {
	return (
		<ModalWrapper title={`Confirm ${activeModal}`} onClose={onClose} className="gap-5 !max-w-[500px]" closeOnOutsideClick>
			<div className="flex flex-col">
				{teamName && <p className="text-base font-medium leading-6 text-gray-900 mb-4">{teamName}</p>}
				<hr />
				{activeModal && <div className="py-4">{modalMessage[activeModal]}</div>}
				<ActionButtons
					className="flex justify-end gap-3"
					closeButtonClassName="w-32 text-gray-700"
					submitButtonClassName="w-32 bg-orange-600 text-white hover:bg-orange-700"
					onClose={onClose}
					onSubmit={onSubmit}
					submitButtonText="Confirm"
					closeButtonText="Cancel"
				/>
			</div>
		</ModalWrapper>
	);
};
